
import React, { useState } from 'react';
import { Languages } from 'lucide-react';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { LANGUAGE_CODES, SupportedLanguage } from '@/hooks/useTranslation';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface InstantTranslationProps {
  currentLanguage: SupportedLanguage;
  onLanguageChange: (language: SupportedLanguage) => void;
}

const InstantTranslation: React.FC<InstantTranslationProps> = ({ 
  currentLanguage, 
  onLanguageChange 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  
  // List of supported languages
  const supportedLanguages = Object.keys(LANGUAGE_CODES) as SupportedLanguage[];
  
  const handleLanguageSelect = (language: SupportedLanguage) => {
    onLanguageChange(language);
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-20 z-50">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
              <DropdownMenuTrigger asChild>
                <Button 
                  variant="secondary" 
                  size="icon" 
                  className="rounded-full shadow-lg"
                >
                  <Languages className="h-5 w-5" />
                  {currentLanguage !== 'English' && (
                    <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
                      {LANGUAGE_CODES[currentLanguage]}
                    </span>
                  )}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-40 p-2">
                {supportedLanguages.map(lang => (
                  <DropdownMenuItem
                    key={lang}
                    className={`flex items-center cursor-pointer ${currentLanguage === lang ? 'bg-secondary' : ''}`}
                    onClick={() => handleLanguageSelect(lang)}
                  >
                    <span className="mr-2 text-xs font-medium">
                      {LANGUAGE_CODES[lang]}
                    </span>
                    <span>{lang}</span>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p>Translate article</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default InstantTranslation;
